export default __webpack_public_path__ + "static/media/game_icon1.636e55a0.png";